const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const parseCalendarDate = (date) => {
    const [year = "", month = "", day = ""] = date.split("-");
    return { year, month, day };
};
const fmtMonthDay = (date) => {
    const { month, day } = parseCalendarDate(date);
    const monthName = MONTH_NAMES[Number(month) - 1] ?? month;
    return `${monthName} ${Number(day)}`;
};
const fmtMonthDayYear = (date) => {
    const { year } = parseCalendarDate(date);
    return `${fmtMonthDay(date)}, ${year}`;
};
// Human-readable date range from optional start/end calendar dates.
export const fmtDateRange = (start, end) => {
    if (start === undefined)
        return "No dates yet";
    if (end === undefined || end === start)
        return fmtMonthDayYear(start);
    const { year: startYear } = parseCalendarDate(start);
    const { year: endYear } = parseCalendarDate(end);
    return startYear === endYear
        ? `${fmtMonthDay(start)} – ${fmtMonthDayYear(end)}`
        : `${fmtMonthDayYear(start)} – ${fmtMonthDayYear(end)}`;
};
// Trip card/header date range (structurally typed so shared needn't import core).
export const fmtTripDates = (t) => fmtDateRange(t.startDate, t.endDate);
//# sourceMappingURL=formatDateRange.js.map